import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore.js';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredUserType?: string;
}

const ProtectedRoute = ({ children, requiredUserType }: ProtectedRouteProps) => {
  const user = useAuthStore(s => s.user);
  const isLoading = useAuthStore(s => s.isLoading);
  console.log('ProtectedRoute - user:', user, 'isLoading:', isLoading);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to={`/signin?returnTo=${encodeURIComponent(window.location.pathname)}`}
        replace
      />
    );
  }

  if (requiredUserType && user.role !== requiredUserType) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;